// função para verificar se a ordem foi paga com cartão corporativo
// o valor pode chegar como número, string ou null, então a conversão é necessária
const isBusinessCard = (value: any) => Number(value) === 1;

const BusinessCardBadgeComponent = ({ value }: { value: any }) => {

    return (
        isBusinessCard(value)

            ?

            <span className="badge bg-success">Sim</span>

            :

            <span className="badge bg-danger">Não</span>
    )

}

export { isBusinessCard };

export default BusinessCardBadgeComponent;
